export const COMMUNITY_MEMBERS_DETAIL_MODE = {
  NON_PUBLIC: 'nonPublic',
  TENANT: 'tenant',
  COMPANY: 'company',
};
